const groupPrefix = createApiRoute(ApiModule.DIETARY, ApiDataModel.MEDIA)

export const apiDietaryMedia = {
	fetchDietaryMedia: async (collection?: EMediaCollection) => {
		const { data } = await apiCommon<IMedia[]>(`${groupPrefix}`, {
			method: 'GET',
			...createQuery(undefined, { collection_name: collection }),
		})

		return data.map(Media)
	},
	storeDietaryMedia: async (files: IFile[], collection: EMediaCollection, modelId: string | number) => {
		const payload = FilesToMediaPayload(files, collection, modelId)

		const { data } = await apiCommon<IMedia[]>(`${groupPrefix}`, { method: 'POST', body: payload }, 'pl', true)

		return data.map(Media)
	},
	reorderDietaryMedia: async (mediaUuids: string[]): Promise<void> => {
		await apiCommon(`${groupPrefix}/order`, { method: 'PUT', body: { order: mediaUuids } })
	},
	destroyDietaryMedia: async (mediaUuids: string[]): Promise<void> => {
		await apiCommon(`${groupPrefix}`, { method: 'DELETE', body: { media: mediaUuids } })
	},
}
